import { showToast } from './toast';
export var WEB_API = {
    SKPage: {
        userInfo: function () {
            // TODO: aa
            throw new Error('SKPage_userInfo is not defined');
        },
        pageInfo: function () {
            return {
                screen_width: window.innerWidth,
                screen_height: window.innerHeight,
                has_navigation_bar: false,
                navigation_bar_height: 0,
                status_bar_height: 0,
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
            };
        },
        pop: function () {
            // TODO: aa
            // history.back();
        },
        lifeCycle: function () {
            // TODO: aa
            // throw new Error('SKPage_lifeCycle is not defined');
        },
    },
    SKNavigation: {
        dispatch: function (params) {
            // TODO: aa
            // try {
            //   openApp(params);
            // } catch (e) {
            //   console.log(e);
            // }
        },
        openURL: function (params) {
            // TODO: aa
            // try {
            //   openApp(params);
            // } catch (e) {
            //   console.log(e);
            // }
        },
    },
    SKShare: {
        /**
         * @description 等待文档
         */
        shareImg: function (options) {
            // TODO: aa
        },
    },
    SKHandle: {
        handleNavBar: function () { },
        handleOrientation: function () { },
    },
    web: {
        showToast: function (params) {
            showToast(params.text, params.timeout);
        },
    },
};
